<div *ngIf="title" class="description">
  <p>{{ title }}</p>
  <ng-container *ngIf="imageUrl">
    <img src="./assets/images/{{ imageUrl }}" />
  </ng-container>
</div>
